import axios from "axios";

export const LOGIN_URL = `${process.env.REACT_APP_API_URL}/authentication/login`;
export const ME_URL = `${process.env.REACT_APP_API_URL}/authentication/me`;
export const REQUEST_PASSWORD_URL = `${process.env.REACT_APP_API_URL}/authentication/recover`;
export const ACTIVATE_PASSWORD_URL = `${process.env.REACT_APP_API_URL}/users/activate`;

export function login(userName, password) {
  return axios.post(LOGIN_URL, { userName, password });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}

export function requestPassword(userName) {
  return axios.post(REQUEST_PASSWORD_URL, { userName });
}

export function activatePassword(token, password) {
  return axios.put(ACTIVATE_PASSWORD_URL, { token, password });
}